import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MediaGallery from './MediaGallery';
import CloudflareVideo from './CloudflareVideo';
// import TailscaleProtection from './TailscaleProtection';
import { getRandomPhotos, getTotalPhotoCount, generateAllPhotos } from '../utils/photoLoader';
import './DF.css';

const DF = () => {
  const [showAllPhotos, setShowAllPhotos] = useState(false);
  const [currentPhotoSet, setCurrentPhotoSet] = useState(() => getRandomPhotos(20));
  
  // Auto-refresh on component mount to trigger middleware check
  useEffect(() => {
    const hasRefreshed = sessionStorage.getItem('df-refreshed');
    if (!hasRefreshed) {
      sessionStorage.setItem('df-refreshed', 'true');
      window.location.reload();
    }
  }, []);
  
  // Helper functions for photo management
  const handleViewAllPhotos = () => {
    setShowAllPhotos(true);
    setCurrentPhotoSet(generateAllPhotos());
  };
  
  const handleViewRandomPhotos = () => {
    setShowAllPhotos(false);
    setCurrentPhotoSet(getRandomPhotos(20));
  };
  
  const getDisplayedPhotos = () => {
    return showAllPhotos ? generateAllPhotos() : currentPhotoSet;
  };
  
  const getPhotoCountText = () => {
    const displayed = getDisplayedPhotos().length;
    const total = getTotalPhotoCount();
    return showAllPhotos ? `All ${total} photos` : `${displayed} of ${total} photos`;
  };

  const videoSections = [
    {
      title: "Pjesa 1",
      description: "The Beginning",
      embedId: "6764dcb5b81d810bf04c4e6264dc2456",
      placeholder: false
    },
    {
      title: "Pjesa 2", 
      description: "The Ceremony",
      embedId: "2018fa37b1fd668f139dcc03f8bed0b0",
      placeholder: false
    },
    {
      title: "Pjesa 3",
      description: "The Celebration",
      embedId: "5b7a55d296805c9bba6b20cd11b5d267", 
      placeholder: false
    }
  ];

  const renderVideoSection = (video, index) => {
    if (video.placeholder) {
      return (
        <div key={index} className="video-placeholder">
          <div className="play-button">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5v14l11-7z"/>
            </svg>
          </div>
          <div className="video-info">
            <h3>{video.title}</h3>
            <p>{video.description}</p>
            <span className="video-note">Video will be embedded here</span>
          </div>
        </div>
      );
    }
    
    return (
      <div key={index} className="video-container">
        <CloudflareVideo
          videoId={video.embedId}
          width={640}
          height={360}
          controls={true}
          autoplay={false}
          muted={false}
          className="wedding-video"
        />
        <div className="video-info">
          <h3>{video.title}</h3>
          <p>{video.description}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="df-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="df-logo">
            <span className="df-symbol">Ɗf</span>
          </div>
          <h1 className="couple-names">
            <span className="fuad">FUAD</span>
            <span className="ampersand">&</span>
            <span className="donika">DONIKA</span>
          </h1>
          <h2 className="family-name">POROSHTICA</h2>
          <div className="hero-tagline">
            <span className="here-we-go">HERE WE GO</span>
          </div>
          <div className="wedding-date">
            A private family engagement ceremony hosted by<br />
            the Poroshtica family on <strong>August 4, 2023</strong>
          </div>
        </div>
        
        {/* Background decoration */}
        <div className="hero-background">
          <div className="gradient-overlay"></div>
        </div>
      </section>

      {/* Video Sections */}
      <section className="video-sections">
        <div className="section-container">
          <h2 className="section-title">Engagement Moments</h2>
          <div className="videos-grid">
            {videoSections.map((video, index) => renderVideoSection(video, index))}
          </div>
        </div>
      </section>

      {/* Photo Gallery Section - Now with Real Wedding Photos */}
      <section className="photo-gallery">
        <div className="section-container">
          <h2 className="section-title">Engagement Gallery</h2>
          <div className="gallery-intro" style={{
            textAlign: 'center',
            marginBottom: '2rem',
            padding: '1rem',
            backgroundColor: '#f9f9f9',
            borderRadius: '8px'
          }}>
            <p style={{ margin: '0.5rem 0', color: '#666', fontSize: '1.1rem' }}>
              Capturing the beautiful moments from Fuad & Donika's special day
            </p>
            <p style={{ margin: '0.5rem 0', color: '#888', fontSize: '0.9rem' }}>
              {getPhotoCountText()} • Click any photo to view in full size
            </p>
            
            {/* Photo Controls */}
            <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
              <Link 
                to="/df/photos"
                style={{
                  padding: '8px 16px',
                  fontSize: '0.9rem',
                  backgroundColor: '#667eea',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  textDecoration: 'none',
                  display: 'inline-block',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#764ba2'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#667eea'}
              >
                🗂️ Browse All Photos ({getTotalPhotoCount()})
              </Link>
              
              {!showAllPhotos && (
                <button 
                  onClick={handleViewAllPhotos}
                  style={{
                    padding: '8px 16px',
                    fontSize: '0.9rem',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                >
                  📸 View All {getTotalPhotoCount()} Photos
                </button>
              )}
              
              <button 
                onClick={handleViewRandomPhotos}
                style={{
                  padding: '8px 16px',
                  fontSize: '0.9rem',
                  backgroundColor: showAllPhotos ? '#28a745' : '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = showAllPhotos ? '#1e7e34' : '#545b62'}
                onMouseOut={(e) => e.target.style.backgroundColor = showAllPhotos ? '#28a745' : '#6c757d'}
              >
                🎲 {showAllPhotos ? 'Show Random Selection' : 'Shuffle Photos'}
              </button>
            </div>
          </div>
          
          {/* Real Wedding Photos Gallery */}
          <MediaGallery
            items={getDisplayedPhotos()}
            lightbox={true}
            showTitles={false}
            className="wedding-photo-gallery"
          />
          
          {showAllPhotos && (
            <div className="all-photos-info" style={{
              marginTop: '2rem',
              padding: '1rem',
              textAlign: 'center',
              backgroundColor: '#e8f5e8',
              borderRadius: '8px',
              border: '2px solid #d4edda'
            }}>
              <p style={{ margin: 0, color: '#155724', fontSize: '1rem' }}>
                ✨ You're viewing all {getTotalPhotoCount()} engagement photos from our special day! ✨
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Made By Section */}
      <section className="made-by">
        <div className="made-by-text">
          MADE BY<br />
          <strong>FUAD</strong>
        </div>
      </section>

      {/* Back to Home */}
      <section className="back-home">
        <Link to="/" className="back-button">
          ← Back to Home
        </Link>
      </section>
    </div>
  );
};

export default DF;